/**
 * @file Base class for view components.
 * @author Tom Verschoore de la Houssaije
 */
import * as tslib_1 from "tslib";
import { AbstractComponent } from '../../core/helpers/abstract-component';
import { AsyncSubject } from 'rxjs';
import { map } from 'rxjs/operators';
import { CONFIGURATION_ROUTE_DATA_PROPERTY } from '../../routes.service';
// TODO: Consider using a CanDeactivate guard instead of ngOnDestroy. Think of message "save before close".
/**
 * Abstract class representing a configurable view.
 */
var AbstractView = /** @class */ (function (_super) {
    tslib_1.__extends(AbstractView, _super);
    /**
     * Constructs AbstractView class
     * @param configurationsService The configuration service.
     * @param router The router
     * @param route The activated route.
     */
    function AbstractView(router, route, breezeService, dialogService, alertsService, translateService) {
        var _this = _super.call(this, alertsService) || this;
        _this.router = router;
        _this.route = route;
        _this.breezeService = breezeService;
        _this.dialogService = dialogService;
        _this.alertsService = alertsService;
        _this.translateService = translateService;
        return _this;
    }
    Object.defineProperty(AbstractView.prototype, "createMode", {
        /**
         * Gets the create mode of the view, this is important to know on deactivate.
         * @readonly
         * @type {boolean} Is True when in create mode.
         */
        get: function () {
            return false;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * Is called directly after the creation of this component.
     */
    AbstractView.prototype.ngOnInit = function () {
        var test = this.route.snapshot.data[CONFIGURATION_ROUTE_DATA_PROPERTY];
        if (!test) {
            return;
        }
        this.configuration = test;
    };
    /**
     * Checks if the domainservice contains changes which are not saved.
     */
    AbstractView.prototype.canDeactivate = function () {
        return this.checkChangesBeforeDeactivate();
    };
    /**
     * Closes the the view.
     * Override this method to add close logic.
     */
    AbstractView.prototype.close = function () {
        // TODO: Consider removing this method from api of AbstractView class.
        // Should close the view.
        throw new Error('Not implemented!');
    };
    /**
     * Checks if there are changes to be saved before deactivate.
     * @protected
     * @returns {(Observable<boolean> | boolean)}
     */
    AbstractView.prototype.checkChangesBeforeDeactivate = function (skipDeleted) {
        var _this = this;
        if (skipDeleted === void 0) { skipDeleted = false; }
        if (this.breezeService.hasChanges(skipDeleted)) {
            // hasChanges() == true does not include added entities.
            var dialogInProgress = this.dialogService.inProgress;
            if (dialogInProgress) {
                var next_1 = new AsyncSubject();
                var savingInProgress = this.breezeService.savingInProgress;
                if (savingInProgress) {
                    this.subscriptionPool.add(savingInProgress.subscribe(function (value) {
                        next_1.next(true);
                        next_1.complete();
                    }));
                    return next_1;
                }
                // dialogInProgress.subscribe(value => {
                //     const change_result = this.checkChangesBeforeDeactivate();
                //     if (typeof change_result === 'boolean') {
                //         next.next(change_result);
                //         next.complete();
                //         return;
                //     }
                //     change_result.subscribe(response => {
                //         next.next(response);
                //         next.complete();
                //         return;
                //     });
                // });
                // Oude code hier boven veroorzaakt loop daarom dit hieronder:
                next_1.next(true);
                next_1.complete();
                return next_1;
            }
            var result = this.dialogService.createDialog(this.translateService.instant('APP.CORE.CHANGES_TITLE'), this.translateService.instant('APP.CORE.CHANGES_MESSAGE'), 'APP.CORE.OK');
            return result.pipe(map(function (value) {
                if (value) {
                    _this.breezeService.rejectChanges();
                }
                return value;
            }));
        }
        else {
            if (this.createMode && this.breezeService.hasAdded()) {
                // The check of createMode is important.
                // Otherwise a new entity can be directly be removed after creation.
                this.breezeService.rejectChanges();
            }
            return true;
        }
    };
    /**
     * Is called by the selectionChanged event of the component that presents the entities and is used to navigate to the details of the selected item.
     * @param item The new selected item.
     * @returns True when an item is selected otherwise false.
     */
    AbstractView.prototype.navigateTo = function (item) {
        if (item === undefined) {
            return false;
        }
        if (item === null) {
            //  Navigate gaat nu fout wanneer je een delete deed op een item. Dan sloot hij de view?
            //  this.router.navigate(['../'], { relativeTo: this.route, queryParams: this.route.snapshot.queryParams });
            return false;
        }
        this.navigateToDetails(item);
        return true;
    };
    /**
     * To navigate to the details of the selected item.
     * @param item The item selected.
     */
    AbstractView.prototype.navigateToDetails = function (item) {
        var _this = this;
        // Simple idee generic detail navigation.
        // TODO: Make more realistic implementation.
        var routes = this.configuration.routes;
        if (!routes) {
            return;
        }
        routes.find(function (routeConfiguration) {
            if (_this.isDetailRouteForItem(routeConfiguration, item)) {
                var path = routeConfiguration.path;
                if (path.includes(':id')) {
                    var key_1 = '';
                    item.entityType.keyProperties.forEach(function (property) {
                        key_1 += item[property.name].toString();
                        key_1 += '_';
                    });
                    if (item.entityType.keyProperties.length > 0) {
                        key_1 = key_1.substring(0, key_1.length - 1);
                    }
                    _this.router.navigate([path.replace(':id', key_1)], { relativeTo: _this.route, queryParams: _this.route.snapshot.queryParams });
                    return true;
                }
                _this.router.navigate([path], { relativeTo: _this.route, queryParams: _this.route.snapshot.queryParams });
                return true;
            }
            return false;
        });
    };
    /**
     * Checks whether the given route is the detail route for the given item.
     * @param detailRoute The route to check.
     * @param item Checks the route for this item.
     * @returns True when detailRoute matches with the given entity otherwise false.
     */
    AbstractView.prototype.isDetailRouteForItem = function (detailRoute, item) {
        return detailRoute.name === 'Details' && item != null;
    };
    return AbstractView;
}(AbstractComponent));
export { AbstractView };
